import React, { useEffect } from 'react';
import styles from './NinthScreen.module.css';
import ScrollReveal from 'scrollreveal';
import Button from '../SecondReceptionistComponents/button/Button';

const NinthScreenRec = () => {
  const comparisonData = [
    {
      forYou: 'נמאס לך שיש לך בוס על הראש ואת מוכנה להפוך לבוסית של עצמך, לקבוע את החוקים וליהנות מהחופש שמגיע לך.',
      notForYou: 'את מחפשת "כסף קל" בלי להשקיע בעבודה יסודית ומקצועית.'
    },
    {
      forYou: 'את מרגישה שהפוטנציאל שלך מתבזבז מאחורי הקלעים של אחרים, ורוצה לקבל סוף סוף את ההכרה (והתגמול) על הערך העצום שאת מביאה.',
      notForYou: 'את לא אוהבת סדר, ארגון או עבודה מול אנשים ומספרים.'
    },
    {
      forYou: 'את חולמת על היום שבו תנהלי את הלו"ז שלך בעצמך, מכל מקום שתרצי.',
      notForYou: 'את מעדיפה להישאר ב"אזור הנוחות" ולא מוכנה מנטלית כרגע ללנהל עסק משלך.'
    },
    {
      forYou: 'את רוצה להתחיל לבנות קריירה רווחית שמבוססת על היכולות שכבר קיימות בך.',
      notForYou: 'את מחפשת קורס תיאורטי בלבד (אנחנו כאן כדי לעבוד בתכל\'ס).'
    },
    {
      forYou: 'את כבר עוזרת אישית או מזכירה ומרגישה שהגיע הזמן לשדרג את המעמד והשכר.',
      notForYou: ''
    },
    {
      forYou: 'את אמא שרוצה קריירה רווחית שמאפשרת גמישות מלאה וניהול זמן עצמאי.',
      notForYou: ''
    },
    {
      forYou: 'את "חולה" על סדר וארגון ובא לך להפוך את זה למקצוע מבוקש עם שליחות',
      notForYou: ''
    }
  ];

  const forYouItems = comparisonData.map(item => item.forYou).filter(Boolean);
  const notForYouItems = comparisonData.map(item => item.notForYou).filter(Boolean);

  useEffect(() => {
    ScrollReveal().reveal(`.${styles.title}`, {
      duration: 1000,
      distance: '30px',
      origin: 'right',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
    });

    ScrollReveal().reveal(`.${styles.tableRow}`, {
      duration: 1000,
      distance: '30px',
      origin: 'bottom',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      interval: 150,
    });

    ScrollReveal().reveal(`.${styles.mobileCard}`, {
      duration: 1000,
      distance: '30px',
      origin: 'bottom',
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
      interval: 100,
    });
  }, []);

  return <>
    <section className={styles.container}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>
          וכדי שתהי בטוחה שהקורס מתאים לך
        </h2>

        {/* Desktop Table View */}
        <div className={styles.tableContainer}>
          <div className={styles.tableHeader}>
            <div className={styles.headerCell}>
              <span className={styles.checkmark}>✓</span>
              <span className={styles.headerText}>הקורס בול בשבילך אם...</span>
            </div>
            <div className={styles.headerCell}>
              <span className={styles.xmark}>✗</span>
              <span className={styles.headerText}>הקורס פחות יתאים לך אם...</span>
            </div>
          </div>

          <div className={styles.tableBody}>
            {comparisonData.map((row, index) => (
              <div key={index} className={styles.tableRow}>
                <div className={`${styles.tableCell} ${styles.forYouCell}`}>
                  {row.forYou && (
                    <>
                      <span className={styles.cellIcon}>✓</span>
                      <p className={styles.cellText}>{row.forYou}</p>
                    </>
                  )}
                </div>
                <div className={`${styles.tableCell} ${styles.notForYouCell}`}>
                  {row.notForYou && (
                    <>
                      <span className={styles.cellIconX}>✗</span>
                      <p className={styles.cellText}>{row.notForYou}</p>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Stacked View */}
        <div className={styles.mobileContainer}>
          {/* For You Section */}
          <div className={styles.mobileSection}>
            <div className={styles.mobileSectionHeader}>
              <span className={styles.checkmark}>✓</span>
              <span className={styles.headerText}>הקורס בול בשבילך אם...</span>
            </div>
            <div className={styles.mobileCards}>
              {forYouItems.map((item, index) => (
                <div key={index} className={`${styles.mobileCard} ${styles.forYouCard}`}>
                  <span className={styles.cellIcon}>✓</span>
                  <p className={styles.cellText}>{item}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Not For You Section */}
          <div className={styles.mobileSection}>
            <div className={styles.mobileSectionHeader}>
              <span className={styles.xmark}>✗</span>
              <span className={styles.headerText}>הקורס פחות יתאים לך אם...</span>
            </div>
            <div className={styles.mobileCards}>
              {notForYouItems.map((item, index) => (
                <div key={index} className={`${styles.mobileCard} ${styles.notForYouCard}`}>
                  <span className={styles.cellIconX}>✗</span>
                  <p className={styles.cellText}>{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        
    <Button text="קרן אני מתאימה בואי נדבר!" />
      </div>
    </section>
    {/* כפתור בתחתית */}
  </>
};

export default NinthScreenRec;